import type { LearningState } from "../types";

const DAY_MS = 24 * 60 * 60 * 1000;

function toDateKey(date: Date) {
  return date.toISOString().slice(0, 10);
}

function parseDay(key: string) {
  return new Date(`${key}T00:00:00.000Z`);
}

export function StreakHeatmap({ state }: { state: LearningState }) {
  const activeDays = new Set(state.sessions.map((session) => session.date));
  const sortedSessionDays = state.sessions.map((session) => session.date).sort();
  const endKey = sortedSessionDays[sortedSessionDays.length - 1] ?? toDateKey(new Date());
  const end = parseDay(endKey);
  const days = Array.from({ length: 28 }, (_, index) => toDateKey(new Date(end.getTime() - (27 - index) * DAY_MS)));

  return (
    <div className="streak-heatmap" aria-label="Aktivitaetskalender">
      {days.map((day) => {
        const active = activeDays.has(day);
        return (
          <span
            aria-label={`${day} ${active ? "aktiv" : "inaktiv"}`}
            className={`heatmap-cell ${active ? "is-active" : ""}`}
            key={day}
            role="img"
          />
        );
      })}
    </div>
  );
}
